var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen--sync"},[_c('h1',[_vm._v(" Invia dati ")]),_c('p',[_vm._v(" Sono presenti "+_vm._s(_vm.entries.length)+" registrazioni. ")]),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.syncEntries()}}},[_vm._v(" Invia dati ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }